import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Polls } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Polls.Pages.POLL}/:id`,
    name: Polls.Pages.POLL,
    component: () => import(/* webpackChunkName: "polls" */ './views/PollDetail.vue'),
    meta: {
      access_roles: RouteRoles[Polls.Pages.POLL],
    },
  },
];

export default routes;
